import React from 'react';

import './index.scss';

//materila-ui
import { CircularProgress, Button, Dialog, DialogActions, DialogContent, DialogTitle, ListItem, createMuiTheme, MuiThemeProvider } from '@material-ui/core';


//api
import {api} from '../../../functions/api';

//custom components
import CustomButton from '../../../components/basic/CustomButton';
import CustomInput from '../../../components/basic/input'
import SelectSearch from '../../../components/basic/SelectSearch/SelectSearch'

//other libraries
import {toJS} from 'mobx';
import { inject, observer } from 'mobx-react';

const theme = createMuiTheme ({
    typography: {
        useNextVariants: true
    },
    overrides: {
        // MuiDialogContent: {
        //     root: {
        //         overflow: "initial",
        //         overflowY: "initial"
        //     }
        // },
        // MuiDialogActions: {
        //     root: {
        //         overflow: "initial"
        //     }
        // }
        MuiDialog: {
            paper: {
                overflow: "hidden !important"
            }
        }
    }
})

@inject('internal')
@inject('translate')
@observer
export default class AddEditDeliveryType extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            openSnackbar: false,
            message: "",
            name: "",
            price: "",
            free_from: "",
            description: "",
            production: null,
            vat: "",
            loadingBtn: false,
            selectedShops: [],
            allShops: []
        }
    }

    componentDidMount() {
        let shopsTmp = toJS(this.props.internal.dataForTable.lists.shops)
        let shops = [];
        for(let i in shopsTmp) {
            let tmp = {
                label: shopsTmp[i].name,
                value: shopsTmp[i].id
            }
            shops.push(tmp);
        }
        this.setState({allShops: shops})

        if(toJS(this.props.internal.actionEdit.edit)) {
            
            this.loadDeliveryType();
        }
        else {
            this.setState({production: false})
        }
        
    }

    handleChangeCheckbox = (event) => {
        this.setState({production: event.target.checked})
    }

    loadDeliveryType = async() => {
        this.setState({loading: true})
        let idDeliveryType = toJS(this.props.internal.actionEdit.id)
        
        let load_delivery_type = await api({
            method: 'get',
            url: `lists/delivery-types/${idDeliveryType}`,
            authorization: this.props.internal.user.access_token,
            
        });

        if(load_delivery_type.success === true) {
            let shopsTmp = load_delivery_type.data.data.available_for
            let shops = [];
            for(let i in shopsTmp) {
                let tmp = {
                    label: shopsTmp[i].name,
                    value: shopsTmp[i].id
                }
                shops.push(tmp);
            }
            this.setState({
                selectedShops: shops,
                name: load_delivery_type.data.data.name,
                price: load_delivery_type.data.data.price,
                free_from: load_delivery_type.data.data.free_from,
                description: load_delivery_type.data.data.description, 
                production: load_delivery_type.data.data.production,
                vat: load_delivery_type.data.data.vat,
            })
        }
        
        this.setState({loading: false})
    }

    createNewDeliveryType = async () => {
        this.setState({loadingBtn: true})
        let name = this.name.state.value;
        let price = Number(this.price.state.value);
        let free_from = Number(this.free_from.state.value);
        let description = this.description.state.value;
        let production = this.state.production;
        let vat = Number(this.vat.state.value)

        let idDeliveryType = toJS(this.props.internal.actionEdit.id)
        let url = 'lists/delivery-types'
        let method = 'post'
        if(idDeliveryType) {
            url += "/" + idDeliveryType;
            method = 'patch';
        }
        

        let create_new_delivery_type = await api({
            method: method,
            url: url,
            authorization: this.props.internal.user.access_token,
            params: {
                name: name,
                price: price,
                description: description,
                free_from: free_from,
                production: production,
                vat: vat
            }
        })
        
        if((create_new_delivery_type.success === false && create_new_delivery_type.status === 201) || create_new_delivery_type.success === true) {
            this.props.internal.setSnackbar(create_new_delivery_type.data.message, true)
            this.props.onClose();
        }
        else {
            let resultError = "";
            if(create_new_delivery_type.data.data.errors) {
                for(let error in create_new_delivery_type.data.data.errors){
                    resultError += create_new_delivery_type.data.data.errors[error] + " "
                }
            }
            this.props.internal.setSnackbar( resultError, true)
        }
        this.setState({loadingBtn: false})
    }

    addShop = async(items) => {
        let idDeliveryType = toJS(this.props.internal.actionEdit.id)
        this.setState({selectedShops: items, loadingBtn: true})
        let ids = items.map(item => item.value)

        let update_data = await api({
            url: `lists/delivery-types/${idDeliveryType}`,
            method: 'patch',
            authorization: this.props.internal.user.access_token,
            params: {
                available_for: ids
            }
        })

        if(update_data.success === true) {
            this.props.internal.setSnackbar(update_data.data.message, true)
        }

        this.setState({loadingBtn: false})
    }

    render() {
        return (
            <MuiThemeProvider theme={theme}>
            <Dialog
                open={this.props.open}
                onClose={this.props.onClose}
                aria-labelledby="form-dialog-title"
                classes={{
                    paper: "delivery-dialog-paper"
                }}

            >
            
                <DialogTitle id="form-dialog-title">{this.props.title}</DialogTitle>
                <DialogContent className={'dialog-delivery_types'}>
                {this.state.loading 
                    ? 
                    <CircularProgress className={'circular-progress'} />  
                    : 
                        <div className={'flex edit-delivery-type flex-column'}>
                        
                            <div className={'flex w-100'}>
                                <CustomInput
                                    ref={ref => this.name = ref}
                                    text={this.props.translate.i18n.MODULES.TRANSPORTS.NAME}
                                    value={this.state.name !== "" ? this.state.name : ""}
                                    id={'title'}
                                    className={"mr-10 w-50"}
                                    required
                                />
                                <CustomInput
                                    ref={ref => this.price = ref}
                                    text={this.props.translate.i18n.MODULES.TRANSPORTS.PRICE}
                                    value={this.state.price !== "" ? this.state.price : ""}
                                    id={'price'}
                                    className={"w-50 text-right"}
                                    required
                                    endAdornment={{position: "end", value: "€"}}
                                    type={'number'}
                                />
                            </div>
                            <div className={'flex w-100'}>
                                <CustomInput
                                    ref={ref => this.free_from = ref}
                                    text={this.props.translate.i18n.MODULES.TRANSPORTS.FREE_FROM}
                                    value={this.state.free_from !== "" ? this.state.free_from : ""}
                                    id={'free_from'}
                                    className={"mr-10 text-right"}
                                    endAdornment={{position: "end", value: "€"}}
                                    type={'number'}
                                />
                                <CustomInput
                                    ref={ref => this.vat = ref}
                                    text={this.props.translate.i18n.MODULES.TRANSPORTS.VAT}
                                    value={this.state.vat !== "" ? this.state.vat : ""}
                                    id={'vat'}
                                    className={"text-right"}
                                    required
                                    endAdornment={{position: "end", value: "%"}}
                                    type={'number'}
                                />
                            </div>
                            <CustomInput
                                ref={ref => this.description = ref}
                                text={this.props.translate.i18n.MODULES.TRANSPORTS.DESCRIPTION}
                                value={this.state.description !== "" ? this.state.description : ""}
                                id={'description'}
                                className={"w-100"}
                                multiline
                            />
                            <SelectSearch
                                options={this.state.allShops}
                                onChange={val => this.addShop(val)}
                                value={this.state.selectedShops}
                                isMulti={true}
                                className={'select-search'}
                                label={this.props.translate.i18n.MODULES.TRANSPORTS.AVAILABLE_FOR}
                                // menuIsOpen
                                // onMenuOpen={this.handleScrollDown}
                            />
                            
                            <ListItem dense onChange={this.handleChangeCheckbox} className={'list-item'}>
                                <input 
                                    id={"production"} 
                                    type="checkbox" 
                                    value={"production"} 
                                    defaultChecked={this.state.production ? this.state.production : false}
                                />
                                <label htmlFor={"production"}>{this.props.translate.i18n.GLOBAL.TABLE.ACTIVE}</label>
                            </ListItem>

                        </div>                    
                    }
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.onClose} className={'gray-text'}>
                        {this.props.translate.i18n.GLOBAL.BUTTONS.CANCEL}
                    </Button>
                    {/* <Button onClick={this.createNewDeliveryType} className={'orange-text'}>
                        {this.props.translate.i18n.GLOBAL.BUTTONS.SAVE}
                    </Button> */}
                    <CustomButton
                            progressBar={this.state.loadingBtn}
                            onClick={this.createNewDeliveryType} 
                            mystyle={'btn-white-bg'}
                            title={this.props.translate.i18n.GLOBAL.BUTTONS.SAVE}
                            justText
                            disabled={this.state.loading}
                        />
                </DialogActions>
                
            </Dialog>
            </MuiThemeProvider>
        );
    }
}


// WEBPACK FOOTER //
// ./src/screens/delivery/AddEdit/index.js